import store from "@/store";
import Curveball from '@/components/game/scenes/Curveball';
import StatusMeters from '@/components/game/sidebar/StatusMeters';

export default [
	{
		path: 'curveball/:id(\\d+)',
		name: "CURVEBALL_REQUEST",
		components: {
			gameSpace: Curveball,
			sidebar: StatusMeters,
		},
		props: {
			gameSpace: () => ({ ...store.state.game.curveballs.active }),
		},
		async beforeEnter(to, from, next) {
			await store.dispatch("game/curveballs/activate", { id: to.params.id });
			next();
		},
	},
	{
		path: 'curveball/serve',
		async beforeEnter(to, from, next) {
			const id = store.getters["game/chapters/active/randomAffordableCurveballId"]();
			const path = id ? `/game/curveball/${id}` : "/game/budget/complete";
			next({ path });
		},
	},
	{
		path: 'curveball/accept',
		async beforeEnter(to, from, next) {
			await store.dispatch("game/curveballs/active/accept");
			next({ path: "/game/budget" });
		},
	},
	{
		path: 'curveball/deny',
		async beforeEnter(to, from, next) {
			await store.dispatch("game/curveballs/active/deny");
			const path = store.getters["game/curveballs/active/willReturn"] ? "/game/curveball/return" : "/game/curveball/complete";
			next({ path });
		},
	},
	{
		path: 'curveball/return',
		async beforeEnter(to, from, next) {
			await store.dispatch("game/curveballs/active/return");
			next({ path: `/game/curveball/${store.state.game.curveballs.active.id}` });
		},
	},
	{
		path: 'curveball/complete',
		async beforeEnter(to, from, next) {
			next({ path: "/game/budget/complete" });
		},
	},
];



// WEBPACK FOOTER //
// ./src/router/curveballs.routes.js